import { render } from "./account-settings.view.vue?vue&type=template&id=2e06a1e7&scoped=true&ts=true"
import script from "./account-settings.view.vue?vue&type=script&lang=ts"
export * from "./account-settings.view.vue?vue&type=script&lang=ts"

import "./account-settings.view.vue?vue&type=style&index=0&id=2e06a1e7&lang=scss&scoped=true"
import "./account-settings.view.vue?vue&type=style&index=1&id=2e06a1e7&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e06a1e7"]])

export default __exports__